import React, { createContext, useContext, useEffect } from 'react';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import { messageInfoWithButton } from '../../modulos/function/mensagemSweetAlert';
import AccessService from '../../services/access/index';
import logout from '../../modulos/function/logout';

const AuthContext = createContext();
const Milliseconds = 3600000;
const Permissions = [1, 2, 3];
const Hours = { One: 1, Four: 4 };


const CheckIntervals = {
    ONE_HOUR: Hours.One * Milliseconds,
    FOUR_HOURS: Hours.Four * Milliseconds
};

export const AuthProvider = ({ children }) => {
    const verifyAuthentication = async () => {
        const lastChecked = localStorage.getItem('lastAuthCheck');
        const now = new Date().getTime();

        const permissao = decriptObjectOnLocalStorage('perm');
        const email = decriptObjectOnLocalStorage('log');
        const status = 1;

        const interval = Permissions.includes(permissao)
            ? CheckIntervals.ONE_HOUR
            : CheckIntervals.FOUR_HOURS;

        if (lastChecked && now - lastChecked < interval) {
            return;
        }

        if (!email) {
            return;
        }

        try {
            const response = await AccessService.checkAccess(
                'permissao-acesso-legado',
                email,
                status,
                'Portal Vendas'
            );

            if (!response) {
                await messageInfoWithButton(
                    `Este portal foi descontinuado para vendas. Clique no botão abaixo para acessar o novo portal.`,
                    'https://portalvendas.grupozelo.com'
                );
                logout();
            }
        } catch (error) {
            console.error('Erro ao verificar acesso:', error);
            logout();
        }

        localStorage.setItem('lastAuthCheck', now);
    };

    useEffect(() => {
        verifyAuthentication();
    }, []);

    return <AuthContext.Provider value={{}}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
